import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import GenericSelect from '../reutilizables/genericSelect/GenericSelect'
import * as categoriasService from '../servicios/categoriasService'

const CaracteristicasProducto = ({
  value,
  onChange,
  idCategoria,
  vieneDeAdministrar
}) => {
  const [metadatos, setMetaDatos] = useState([])
  const [unidades, setUnidades] = useState({})

  useEffect(() => {
    const obtenerMetaDatos = async () => {
      if (idCategoria > 0) {
        const { data } = await categoriasService.buscarMetadato(idCategoria)
        setMetaDatos(data.length > 0 ? data : [])
      }
    }

    obtenerMetaDatos()
  }, [idCategoria])

  const onHandleBlur = (e, idMetaDato, esUnidad = false) => {
    const metadatosValues = [...value['metadatos']]

    let valorFinal = e.target.value

    const indice = metadatosValues.findIndex((m) => m.IdMetaDato === idMetaDato)

    if (esUnidad) {
      const metadato = metadatosValues[indice]
      const valorBase = metadato?.valor?.split(' ')[0] || ''
      valorFinal = `${valorBase} ${e.target.value}`.trim()
    } else {
      const unidad = unidades[idMetaDato]
      if (unidad) {
        valorFinal = `${e.target.value} ${unidad}`.trim()
      }
    }

    if (valorFinal) {
      if (indice !== -1) {
        metadatosValues[indice] = { IdMetaDato: idMetaDato, valor: valorFinal }
      } else {
        metadatosValues.push({ IdMetaDato: idMetaDato, valor: valorFinal })
      }

      onChange(
        { currentTarget: { name: 'metadatos', value: metadatosValues } },
        'calc',
        metadatosValues
      )
    }
  }

  const handleUnidadChange = (e, idMetaDato) => {
    setUnidades((prev) => ({
      ...prev,
      [idMetaDato]: e.target.value
    }))
    if (e.target.value) {
      onHandleBlur(e, idMetaDato, true)
    }
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Cuanta más información tenga la publicación, más fácil será vender el producto.
        </p>
      )}
      {metadatos.map((metadato) => (
        <div key={metadato.idMetaDato} className="row">
          <div className="d-none d-md-block col-md-3 text-right">
            {metadato.etiqueta}:
          </div>
          <div className="d-block d-md-none col-12">{metadato.etiqueta}:</div>
          <div className="col-12 col-md-9">
            {metadato.idMetaDatoTipo === 'boolean' ? (
              <GenericSelect
                options={[
                  { value: 'Si', label: 'Si', key: 'si' },
                  { value: 'No', label: 'No', key: 'no' }
                ]}
                className="w-60"
                name="metadatos"
                value={
                  value.metadatos.find((m) => m.IdMetaDato === metadato.idMetaDato)
                    ?.valor || ''
                }
                onChange={(valor) =>
                  onHandleBlur(
                    {
                      currentTarget: { name: 'metadatos', value: valor },
                      target: { value: valor }
                    },
                    metadato.idMetaDato
                  )
                }
              />
            ) : (
              <>
                <input
                  type={
                    metadato.idMetaDatoTipo === 'number' ||
                    metadato.idMetaDatoTipo === 'number_unit'
                      ? 'number'
                      : 'text'
                  }
                  name={'metadatos'}
                  className="input-text-bordered w-40"
                  onBlur={(e) => e.target.value && onHandleBlur(e, metadato.idMetaDato)}
                ></input>
                {(metadato.idMetaDatoTipo === 'number' ||
                  metadato.idMetaDatoTipo === 'number_unit') && (
                  <input
                    type="text"
                    placeholder="Unidad"
                    name={`unidad_${metadato.idMetaDato}`}
                    className="input-text-bordered w-25"
                    onBlur={(e) =>
                      e.target.value && handleUnidadChange(e, metadato.idMetaDato)
                    }
                  />
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </>
  )
}

CaracteristicasProducto.propTypes = {
  value: PropTypes.shape({
    metadatos: PropTypes.array
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  idCategoria: PropTypes.number.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default CaracteristicasProducto
